import { WheelOfLife } from "./components/WheelOfLife";
import { AdSpace } from "./components/AdSpace";
import { UpdateBanner } from "./components/UpdateBanner";
// import { DonationBanner } from "./components/DonationBanner";
// import { LanguageSwitcher } from "./components/LanguageSwitcher";
import { useTranslation } from "react-i18next";
import { trackEvent } from "./analytics";

export default function App() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background">
      {/* Skip to main content link for screen readers */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-primary text-primary-foreground px-4 py-2 rounded-md z-50"
      >
        Skip to main content
      </a>

      <header role="banner" aria-label="Application header">
        <div className="w-full">
          <div className="container mx-auto px-4 py-2">
            <div className="flex justify-center items-center">
              <UpdateBanner />
            </div>
          </div>
        </div>

        {/* Header Ad Banner */}
        {/* <div className="w-full border-b border-border/50">
          <div className="container mx-auto px-4 py-2">
            <AdSpace position="header" />
          </div>
        </div> */}
      </header>

      <main id="main-content" role="main" aria-labelledby="page-title">
        <div className="container mx-auto px-4 py-8">
          <div className="text-center mb-8">
            <h1 id="page-title" className="mb-4">
              {t("app.title")}
            </h1>
            <p
              className="text-muted-foreground max-w-2xl mx-auto"
              id="page-description"
            >
              {t("app.description")}
            </p>
          </div>
          <WheelOfLife />
        </div>
      </main>

      {/* Footer Ad Space */}
      <footer
        role="contentinfo"
        aria-label="Application footer"
        className="border-t border-border/50 mt-16"
      >
        <div className="container mx-auto px-4 py-6 text-center">
          {/* <AdSpace position="footer" /> */}
          <p className="text-muted-foreground">
            <a
              href="mailto:admin@rodadavida.net"
              onClick={() =>
                trackEvent("contact_click", "Contact", "admin@rodadavida.net", 1)
              }
            >
              admin@rodadavida.net
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
}
